import { getEnv } from '@ctct/ctct-helpers';

import type { PromoValidationBody } from './types/billing.types';
import { BaseApiClient } from '../BaseApiClient';
import { urlParams } from '../UrlParams';

class BillingSvcApi {
  /*
  Note: Billingsvc should be exposed to the front-end as
  little as possible. If additional endpoints are needed,
  you should ask for a myaccount-api proxy endpoint(s) to
   be created instead of adding more billingsvc endpoints
   to app-gateway.
  */
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v1/billing`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public getActivePromotions() {
    return this.baseApiClient.get<unknown>('/promotions/active');
  }

  public getIsTierFloorBilling() {
    return this.baseApiClient.get<unknown>('/istierfloorbilling');
  }

  public getRecommendedUpgradePlanPromotion() {
    const promoCodes = urlParams.getPromoCodes();
    const params = promoCodes.length > 0 ? { promoCode: promoCodes[0] } : {};

    return this.baseApiClient.get<unknown>('/upgradeplan/promotion', params);
  }

  public getRecurringUsage() {
    return this.baseApiClient.get<unknown>('/usage/type/SMS', { credentials: 'include' });
  }

  public getAccount() {
    return this.baseApiClient.get<unknown>('/account', { credentials: 'include' });
  }

  public getSuspensionInfo() {
    return this.baseApiClient.get<unknown>('/suspend');
  }

  public postSetPromotion(promotionCode: string, username: string) {
    return this.baseApiClient.post<unknown, unknown>(
      `/promotion/${promotionCode}`,
      {},
      {
        updateBy: username,
      }
    );
  }

  public postGetPromoValidation(body: PromoValidationBody) {
    return this.baseApiClient.post('/promotions/validation', body);
  }
}

export const billingSvcApi = new BillingSvcApi();

export type BillingSvcApiClient = typeof billingSvcApi;
